import axios from "axios";
import keycloak from "../keycloak";

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.request.use((config) => {
    const user = sessionStorage.getItem("user");
    if (user) {
        config.headers["x-auth-token"] = JSON.parse(user).token;
    }
    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                sessionStorage.removeItem("user");
                window.location.href = "/";
            }

            if (status === 403) {
                sessionStorage.removeItem("user");
                keycloak.logout({
                    redirectUri: window.location.origin,
                });
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
